import { Component, effect, inject } from '@angular/core';
import { CommonService } from '@shared/services/Common/common.service';

@Component({
  selector: 'app-alert',
  imports: [],
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  cs = inject(CommonService);
  alert = this.cs.alertSignal;

  lastType: string | undefined = undefined;
  lastMessage: string | undefined = undefined;

  _ = effect(() => {
    const a = this.alert();
    if (a) {
      this.lastType = a.type;
      this.lastMessage = a.message;
    }
  });
}
